<template>
  <help-dialog title="Entities">
    <template #default>
      <h3 class="mb-1 text-black">
        <span class="bg-grey-lighten-3">Entities</span>
      </h3>
      <p class="text-grey-darken-3">
        An <b>Entity</b> contains a set of fields or attributes and is often implemented as a database table or type definition.
        <br /><br />
        <b>Entities</b> can be connected to other <b>Entities</b>, forming a hierarchy of related data.
        They are used by both <b>Read Models</b> and <b>Commands</b>.
        <br /><br />
        Each <b>Command</b> should have one <b>Entity</b> designated as the <b>Aggregate Root</b>. This serves as
        the primary <b>Entity</b> that a <b>Command</b> operates on.

        <br /><br />
        <b>Read Models</b> can also be linked to <b>Entities</b>, as they retrieve and present data in response to queries.
      </p>
      <br />
      <p class="text-grey-darken-3">
        An <b>Entity</b> contains a set of data fields with example data. The following actions are available for each field:
      </p>
      <ul class="ml-5">
        <li><b>Change data type:</b>&nbsp;Set the field's data type (string, number, boolean, or object).
          For object fields, select a related Entity to indicate an entity relationship.
        </li>
        <li>
          <b>Set as required/optional:</b>&nbsp;Toggles whether the field is required or not.
        </li>
        <li>
          <b>Generate example data:</b>&nbsp;Uses AI to automatically populate the field with sample values.
          This example data is used in the <b>Data Fields</b> tab in the sidebar to help you preview how forms will look.
        </li>
        <li><b>Delete:</b>&nbsp;Removes the field from the list.</li>
      </ul>
      <br /><br />
      <p class="text-grey-darken-4">
        To read our full guide to Entities and how to use them in Domain-Driven Design,
        <a
          href="https://www.qlerify.com/domain-driven-design-tool"
          target="_blank"
          class="text-blue-accent-4"
        >
          click here
        </a>.
      </p>
    </template>
  </help-dialog>
</template>

<script setup>
import HelpDialog from '@/components/HelpDialog.vue'
</script>
